import React from 'react';
import { formatNisAmount } from '../../utils/labData';

/**
 * Footnote for spend that is not tied to a Budget.
 * Hidden when the API reports no unassigned amount.
 *
 * @param {Object} props
 * @param {{ total_nis?: string|number, order_count?: number, line_count?: number }|null} [props.unassigned]
 */
const UnassignedSpendCard = ({ unassigned }) => {
  if (!unassigned || Number(unassigned.total_nis ?? 0) === 0) {
    return null;
  }

  return (
    <div className="glass-panel lab-data-unassigned">
      <p className="lab-data-kpi__label">Unassigned spend</p>
      <p className="mb-0">
        {formatNisAmount(unassigned.total_nis)} across {unassigned.order_count ?? 0}{' '}
        orders ({unassigned.line_count ?? 0} lines) — credit-funded or legacy lines without a
        Budget.
      </p>
    </div>
  );
};

export default UnassignedSpendCard;
